import React, { useState, useEffect } from "react";
import { ReptoolModal } from "../../utilities/ReptoolModal.tsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Button, FormControl } from "react-bootstrap";
import { SelectCollectionReptileModal } from "./SelectCollectionReptileModal.tsx";
import { formatDate } from '../../utilities/FormatDate.ts';
import { BasicFetch } from "../../../utils/BasicFetch.ts";
import { Clutch } from "../types/Clutch.ts";
import { driver } from "driver.js";
import { CollectionReptile, Pairing } from "../../collection/types/CollectionTypes.ts";
import { ChoosePairingModal } from "./ChoosePairingModal.tsx";
import { Gene } from "../../../types/Gene.ts";
import { Morph } from "../../../types/Morph.ts";
import { useRepToolContext } from "../../../RepToolContext.tsx";
const SelectedReptile = ({ reptile, borderless }: {
  reptile: CollectionReptile;
  borderless?: boolean;
}) => (
  <div className={`${borderless ? '' : 'border'} rounded flex-fill p-2`}>
    <div className="rounded" style={{ overflow: "hidden" }}>
      <img src={reptile.picture || "images/notavailable.jpg"} width={100} />
      <div className="text-center"><small className="mb-0 bg-black text-center text-light">{reptile.name || reptile.morph_name}</small></div>
    </div>
  </div>
)

export const AddReptile = ({ reptile, borderless = false }: {
  reptile: CollectionReptile | null;
  borderless?: boolean;
}) => (
  <>
    {reptile ? <SelectedReptile borderless={borderless} reptile={reptile} /> : <div
      className="border glow p-5 rounded"
    >
      <FontAwesomeIcon icon={faPlus} size="3x" />
    </div>}
  </>
)


export const AddClutchModal = ({ closeModal, editingClutch, onSave, genes, morphs }: {
  closeModal: () => void;
  editingClutch: Clutch;
  onSave: () => void;
  genes: Gene[];
  morphs: Morph[];
}) => {
  const [openSelectModal, setOpenSelectModal] = useState<boolean>(false);
  const [openPairingModal, setOpenPairingModal] = useState<boolean>(false);
  const [sexFilter, setSexFilter] = useState<'male' | 'female' | undefined>(undefined);
  const [selectedMale, setSelectedMale] = useState<CollectionReptile | null>(editingClutch?.father || null);
  const [selectedFemale, setSelectedFemale] = useState<CollectionReptile | null>(editingClutch?.mother || null);
  const [selectedPairing, setSelectedPairing] = useState<Pairing | null>(editingClutch?.pairing || null);
  const [laidDate, setLaidDate] = useState<string>(editingClutch ? new Date(editingClutch?.laid_date).toISOString() : new Date().toISOString());
  const [numberOfEggs, setNumberOfEggs] = useState<number>(editingClutch?.number_of_eggs || 0);
  const [numberOfSlugs, setNumberOfSlugs] = useState<number>(editingClutch?.number_of_slugs || 0);
  const [saving, setSaving] = useState<boolean>(false);
  const { appendControls } = useRepToolContext();
  const createClutch = () => {
    if (!selectedMale || !selectedFemale) {
      alert("Please Select a male and female")
      setSaving(false);
      return;
    }
    if (numberOfEggs <= 0) {
      alert("Please enter a valid number of eggs");
      setSaving(false);

      return;
    }
    const data = {
      'clutch_id': editingClutch?.id || null,
      'pairing_id': selectedPairing?.id || null,
      'mother_id': selectedFemale.id,
      'father_id': selectedMale.id,
      'laid_date': laidDate,
      'number_of_eggs': numberOfEggs,
      'number_of_slugs': numberOfSlugs,
      'reptile': localStorage.getItem('selectedReptile')
    }
    const url = editingClutch?.id ? `${(window as any).serverLocation}clutch/${editingClutch.id}/edit` : `${(window as any).serverLocation}clutch/create`;
    BasicFetch({
      url,
      method: editingClutch?.id ? 'PATCH' : 'POST',
      contentType: 'application/json',
      data,
      onSuccess: (data) => {
        const successMessage = editingClutch?.id ? "Clutch updated!" : "Clutch created!";
        alert(successMessage);
        onSave();
        closeModal();
      },
      onFail: (err) => {
        alert(err ?? "Failed to create clutch");
      },
      onFinish: () => {
        setSaving(false);
      }
    })
  }

  const setUpCalendar = (value: Date) => {
    (window as any).setUpCalendar(
      "Laid Date",
      () => (date: Date) => {
        setLaidDate(date);
        (window as any).closeCalendar();
      },
      value
    );
  }

  useEffect(() => {
    if (saving) {
      createClutch();
    }
  }, [saving]);

  useEffect(() => {
    // if the mother or father are different from the pairings, set the selectedPairing to null
    if (selectedPairing && selectedFemale && selectedMale) {
      if (selectedPairing.father?.id !== selectedMale.id || selectedPairing.mother?.id !== selectedFemale.id) {
        setSelectedPairing(null);
      }
    }

  }, [selectedMale, selectedFemale]);

  useEffect(() => {
    appendControls(<div className="text-center w-100">
      <span className="d-flex"  >
        <Button id="save-btn" variant="outline-light" disabled={saving} onClick={() => setSaving(true)} className="mx-auto col-6">Save</Button>
      </span>
    </div>, "Create Clutch");
  }, [openSelectModal, openPairingModal]);

  const driverObj = driver({
    steps: [
      { element: '#create-clutch-modal #parents', popover: { title: 'Parents', description: "This is where you will specify the parents of your clutch. Make sure to create the parents in the my collection section if you haven't already." } },
      { element: '#create-clutch-modal #number-of-eggs', popover: { title: 'Number of eggs', description: "Specify the size of the clutch." } },
      { element: '#create-clutch-modal #number-of-slugs', popover: { title: 'Number of slugs', description: "These are the number of 'bad' eggs. It can be useful to keep track of this information so that you may know what to expect for future clutches." } },
      { element: '#create-clutch-modal #laid-date', popover: { title: 'Laid date', description: 'The date this clutch was laid.' } },
      { element: '#save-btn', popover: { title: 'Save', description: 'Save the clutch to your collection.' } }
    ]
  });


  return (
    <>
      {openSelectModal && <SelectCollectionReptileModal
        closeModal={() => setOpenSelectModal(false)}
        sexFilter={sexFilter}
        genes={genes}
        morphs={morphs}
        onSelect={(reptile) => {
          if (sexFilter === "male") {
            setSelectedMale(reptile);
          } else {
            setSelectedFemale(reptile);
          }
          setOpenSelectModal(false);
        }}
      />}
      {
        openPairingModal && <ChoosePairingModal
          closeModal={() => setOpenPairingModal(false)}
          onSelect={(pairing) => {
            setSelectedMale(pairing.father);
            setSelectedFemale(pairing.mother);
            setSelectedPairing(pairing);
            setOpenPairingModal(false);
          }}
        />
      }
      <ReptoolModal
        id='create-clutch-modal'
        title="Create Clutch"
        closeModal={closeModal}
        showTutorial={() => driverObj.drive()}
        body={
          <div className="d-flex flex-column pb-5">
            <div id="parents" className="d-flex flex-row justify-content-around">
              <div className="text-center col-md-4 col-5">
                <h5>Sire:</h5>
                <div onClick={() => { setSexFilter("male"); setOpenSelectModal(true) }}>
                  <AddReptile reptile={selectedMale} />
                </div>
              </div>
              <div className="col-md-4 d-none d-md-flex">
                <div className="d-flex justify-content-center m-auto">
                  <Button variant="outline-light" onClick={() => setOpenPairingModal(true)} className="mx-auto">Choose Pairing</Button>
                </div>
              </div>

              <div className="text-center col-md-4 col-5 ">
                <h5>Dam:</h5>
                <div onClick={() => { setSexFilter("female"); setOpenSelectModal(true) }}>
                  <AddReptile reptile={selectedFemale} />
                </div>
              </div>
            </div>
            <div className="d-flex flex-row justify-content-around d-md-none mt-3">
              <Button variant="outline-light" onClick={() => setOpenPairingModal(true)} className="mx-auto">Choose Pairing</Button>
            </div>
            {selectedPairing && <div className="my-3">
              <h5>Pairing Notes:</h5>
              <p className="mb-0">{selectedPairing?.notes}</p>
            </div>}
            <hr />
            <div id="number-of-eggs">
              <div className="d-flex">
                <h5>Number of eggs </h5>
                <small className="ml-3 my-auto text-light">(including slugs)</small>
              </div>
              <FormControl min={0} value={numberOfEggs} onChange={(event) => {
                setNumberOfEggs(parseInt(event.target.value))
              }} type="number" />
            </div>
            <div id="number-of-slugs" className="mt-3">
              <h5>Number of slugs</h5>
              <FormControl min={0} max={numberOfEggs} value={numberOfSlugs} onChange={(event) => setNumberOfSlugs(parseInt(event.target.value))} type="number" />
            </div>
            <h6 className="mt-3">Total Viable Eggs: {Math.max(numberOfEggs - numberOfSlugs, 0)}</h6>
            <small className="text-light">(number of eggs - number of slugs)</small>
            <hr />
            <div id="laid-date" className="mt-3 pb-4">
              <h5>Laid date</h5>
              <div className="d-flex flex-row justify-content-between">
                <div className="flex-fill">
                  <input className="form-control text-dark" onClick={() => setUpCalendar(new Date(laidDate))} type="text" value={formatDate(laidDate).toLocaleDateString()} readOnly />
                </div>
              </div>
            </div>
          </div >
        } />
    </>

  )
}
